module.exports = __webpack_public_path__ + "img/image-03.52924e52.svg";